<template>
  <div class="hostDialog">
    <el-dialog
      :visible.sync="status"
      width="30%"
      title="新增从机"
      :close-on-click-modal="false"
    >
      <div class="dialog__main">
        <p><img src="../img/dialogAddIcon.png" />{{ title }}</p>
        <el-form :model="form" ref="form" class="form" :rule="rules">
          <el-form-item
            label="设备名称"
            prop="terminalName"
            :label-width="formLabelWidth"
          >
            <el-input size="large" v-model="form.terminalName"></el-input>
          </el-form-item>
          <el-form-item
            label="设备imel"
            prop="imei"
            :label-width="formLabelWidth"
          >
            <el-input size="large" v-model="form.imei"></el-input>
          </el-form-item>
          <el-form-item label="通信地址" prop="addr485"     :label-width="formLabelWidth">
            <el-select size="large" v-model="form.addr485" placeholder="请选择通信地址">
              <el-option

                v-for="item in ableaddrList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>

            </el-select>

          </el-form-item>
          <el-form-item
            label="启停"
            prop="enableStatus"
            :label-width="formLabelWidth"
          >
            <el-switch
              v-model="form.enableStatus"
              active-color="#13ce66"
              inactive-color="#ff4949"
              size="large"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="物联网卡号"-->
<!--            prop="sim"-->
<!--            :label-width="formLabelWidth"-->
<!--          >-->
<!--            <el-input v-model="form.sim" size="large"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="备注"
            prop="remark"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="form.remark"
              type="textarea"
              size="large"
            ></el-input>
          </el-form-item>

          <el-form-item label="照片上传" :label-width="formLabelWidth">
            <el-upload
              class="upload-img"
              name="file"
              :headers="headers"
              :action="uploadUrl"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              list-type="picture-card"
              :on-exceed="handleExceed"
              :on-success="imgsucc"
              :file-list="fileList"
            >
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
              </span>
              <!--                <el-button size="small" type="primary">点击上传</el-button>-->
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确 定</el-button>
        <el-button @click="status = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="图片" :close-on-click-modal="false" :visible.sync="showbigimg" width="550px">

      <img :src=bigimgurl alt="">
    </el-dialog>
  </div>
</template>

<script>
import Axios from "../../../../utils/Axios";
export default {
  name: "hostDialog",
  props: {},
  data() {
    return {
      status: false,
      title: "",
      rules: {
        imei: [{ required: true, message: "请输入imei", trigger: "blur" }],
        enableStatus: [
          { required: true, message: "请选择状态", trigger: "blur" },
        ],
      },
      form: {
        deptId: 1,
        enableStatus: 1,
        imei: "",
        picturePaths: [],
        remark: "",
        sim: null,
        terminalName: "",
        addr485:"",
        showbigimg: false,
        fileList: [],
      },
      fileList:[],
      deptNameList: null,
      treelist:[],
      checkurl:[],
      showbigimg: false,
      bigimgurl: "",
      deptList: [],
      ableaddrList: [],
      hostTerminalId:"",
      formLabelWidth: "90px",

    };
  },
  computed: {
    uploadUrl() {
      return this.baseUrl + "device/uploadPicture";
    },
    headers() {
      return {
        authorization:sessionStorage.getItem("token"),
      };
    },
  },
  methods: {
    getcongaddr(id){
      //获取地址列表
      let that = this;
      let param = {};
      param.method="post";
      param.url="/device/findAvlAddr485";
      param.data={
        terminalId:id
      }
      Axios.ajax(param).then((res)=>{

        if(res.data){

          that.ableaddrList=[]
          for(let i=0;i<res.data.length;i++){
            that.ableaddrList.push({label:res.data[i],value:res.data[i]})
          }

        }

      })
    },
    changelabelToid(label){
      for(let i=0;i<this.treelist.length;i++){
        if(this.treelist[i].label==label){
          return this.treelist[i].value
        }
      }
    },
    cleardata(){
      this.form={
        deptId: 1,
        enableStatus: 1,
        imei: "",
        picturePaths: [],
        remark: "",
        sim: null,
        terminalName: "",
        showbigimg: false,
        fileList: [],
        addr485:""
      }
      this.deptNameList=[]
      this.checkurl=[]
    },
    confirm() {
      let that=this

      this.$refs.form.validate((va) => {

        // if(Array.isArray(that.deptNameList)==false){
        //   that.form.deptName=that.deptNameList
        // }else{
        //   that.form.deptName=that.deptNameList[that.deptNameList.length - 1]
        // }
        // this.deptNameList=null
        // let deptId=this.changelabelToid(this.form.deptName)
        let picturePaths=[]
        for(let i=0;i<this.checkurl.length;i++){
          if(this.checkurl[i].path){
            picturePaths.push(this.checkurl[i].path)
          }else{
            picturePaths.push(this.checkurl[i].response.data.picturePath)
          }

        }
        Axios.ajax({
          url: "/device/addSlave",
          method: "post",
          data:{
            hostTerminalId:this.hostTerminalId,
            addr:this.form.addr485,
            imei:this.form.imei,
            remark:this.form.remark,
            picturePaths:picturePaths,

            enableStatus:this.form.enableStatus,
            terminalName:this.form.terminalName,
          },
        }).then((res) => {
          if(res.resultCode=='0'){
            that.$message({
              type: 'success',
              message:"添加成功"
            });
            this.status=false
            this.queryDepList()
       this.$emit("gettabledata", true)
          }else{
            that.$message({
              type: 'error',
              message: res.resultMessage
            });
          }
        });
      });
    },
    controlDialog(str,id,hostTerminalId,deptList) {
      this.status = true;
      this.deptList = deptList;
      this.title = str;
      this.hostTerminalId = hostTerminalId;
      this.getcongaddr(id)
      this.cleardata()
    },


    handlePreview(file) {
      //点击放大镜触发
      this.showbigimg = true;

      if (file.path) {
        this.bigimgurl = file.url;
      } else {
        this.bigimgurl = file.response.data.pictureUrl;
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm("ok");
    },
    imgsucc(val, file, fileList) {
      this.checkurl = fileList;
    },
    handleRemove(file, fileList) {
      this.checkurl = fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
  mounted() {

    },
  created() {

  },
  watch:{
    status(){
      if(this.status==false){
        this.checkurl=[]
        this.fileList=[]
      }
    },
  }
};
</script>

<style lang="less" scoped>
.hostDialog {
  .dialog__main {
    p {
      margin: 0 0 10px 20px;
      height: 30px;
      line-height: 10px;
      img {
        margin-right: 12px;
      }
    }
  }
}
</style>
